import { render, staticRenderFns } from "./ShowRfRemote.vue?vue&type=template&id=37527b8c"
import script from "./ShowRfRemote.vue?vue&type=script&lang=js"
export * from "./ShowRfRemote.vue?vue&type=script&lang=js"
import style0 from "./ShowRfRemote.vue?vue&type=style&index=0&id=37527b8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports